// extracted by mini-css-extract-plugin
export var statItem = "_cu-1";
export var statsRow = "_cu-0";